/* One cart row, several Shopify lines.

   Shopify splits a line when a discount touches part of its quantity, and the
   cart drawer and cart page draw one row per product instead (client, 23 Sep:
   "consolidate the total quantity into one product line"). The row carries
   data-anyra-merge="key1,key2". The theme changes a line by its 1-based index,
   which on a merged row would move only the first line, so a change on a
   merged row goes to /cart/update.js by line key: the first line takes the new
   total, the others go to zero, and Shopify re-splits by discount on its own.
   The remove cross uses the same path with a quantity of zero.

   Loaded on its own, not inside anyra-gift-pick.js, because the merged rows
   render whether or not the free gifts are switched on (review, 24 Sep). */
(() => {
  const ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  customElements.whenDefined('cart-items').then(() => {
    const CI = customElements.get('cart-items');
    if (!CI || CI.prototype.__anyraMerge) return;
    const original = CI.prototype.updateQuantity;
    CI.prototype.__anyraMerge = true;
    CI.prototype.updateQuantity = function (line, quantity, name, target) {
      const row = this.querySelector('#CartDrawer-Item-' + line + '[data-anyra-merge], #CartItem-' + line + '[data-anyra-merge]');
      if (!row) return original.call(this, line, quantity, name, target);
      const keys = row.dataset.anyraMerge.split(',').filter(Boolean);
      const updates = {};
      keys.forEach((k, i) => { updates[k] = i === 0 ? Math.max(0, parseInt(quantity, 10) || 0) : 0; });
      this.showLoader(line);
      const sectionsToBundle = [];
      document.documentElement.dispatchEvent(new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sectionsToBundle } }));
      fetch(ROOT + 'cart/update.js', { ...FoxTheme.utils.fetchConfig(), body: JSON.stringify({ updates, sections: sectionsToBundle }) })
        .then((r) => r.json())
        .then((state) => {
          FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { sources: 'cart-items', cart: state, target, line, name });
        })
        .catch((e) => { console.warn('[anyra-merge]', e); this.hideLoader(line); });
    };
  });
})();
